$(document).ready(function () {
  $(".increase").on("click", function () {
    var n = $(this).siblings(".number"),
      i = parseInt(n.val(), 10),
      i = isNaN(i) ? 0 : i;
    n.val(++i);
  }),
    $(".decrease").on("click", function () {
      var n = $(this).siblings(".number"),
        i = parseInt(n.val(), 10),
        i = isNaN(i) ? 0 : i;
      n.val((i = i < 2 ? 1 : i - 1));
    });
});

document.addEventListener("DOMContentLoaded", function () {
  var footer = document.querySelector("#main-cart-footer");
  var items = document.querySelector(".box-cart__insert");
  if (footer && items) {
    items.appendChild(footer);
  }
});
